<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="专家信息入库" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" v-if="editData.djzt === '提交'" type="danger" @click="onCancel">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                            <FGCollapsiblePanel title="专家信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="9">
                                        <a-form-item label="入库单编号" :wrapper-col="{ span: 12 }">
                                            <a-input ref="rkdbh" v-model="editData.rkdbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="姓名" :wrapper-col="{ span: 12 }">
                                            <a-input ref="xm" v-model="editData.xm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="4">
                                        <div class="image-container">
                                            <UploadImage :attachCfg="attachImageCfg" item-name="照片" :state="2" />
                                        </div>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="性别" :wrapper-col="{ span: 12 }">
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="身份证号" :wrapper-col="{ span: 12 }">
                                            <a-input ref="sfzh" v-model="editData.sfzh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="微信号" :wrapper-col="{ span: 12 }">
                                            <a-input ref="wxh" v-model="editData.wxh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="本人手机" :wrapper-col="{ span: 12 }">
                                            <a-input ref="brsj" v-model="editData.brsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位电话" :wrapper-col="{ span: 12 }">
                                            <a-input ref="dwdh" v-model="editData.dwdh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                所属行业:按照21个行业分类选择,可多选。1.农业、林业；2.水利水电；3.电力(含火电、水电、核电、新能源)；4.煤炭；5.石油天然气；6.公路；7.铁路、城市轨道交通；8.民航；9.水运(含港口河海工程)；10.电子、信息工程(含通信、广电、信息化)；11.冶金(含钢铁、有色)；12.石化、化工、医药；13.核工业；14.机械(含智能制造)；15.轻工、纺织；16.建材；17.建筑；18.市政公用工程；19.生态建设和环境工程；20.水文地质、工程测量、岩土工程；21.其他(以实际专业为准)。
                                            </template>
                                            <a-form-item label="所属行业" :wrapper-col="{ span: 12 }">
                                                <a-input ref="sshy" v-model="editData.sshy" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="专家类型" :wrapper-col="{ span: 12 }">
                                            <FGDictSelectCN ref="zjlx" dictNo="XZJ200101" v-model="editData.zjlx" disabled mode="multiple" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <a-form-item label="行政职务" :wrapper-col="{ span: 12 }">
                                                <a-input ref="xzzw" v-model="editData.xzzw" disabled />
                                            </a-form-item>
                                            <template slot="title">
                                                指申请人在社保缴纳单位的行政职务,如没有则填“无”
                                            </template>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人擅长的专业,例如:煤炭行业中的采煤专业、洗选煤专业,如有多个专业可同时填写。
                                            </template>
                                            <a-form-item label="专业" :wrapper-col="{ span: 12 }">
                                                <a-input ref="zy" v-model="editData.zy" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人社保缴纳单位全称,如退休请填退休前所在单位。
                                            </template>
                                            <a-form-item label="工作单位" :wrapper-col="{ span: 12 }">
                                                <a-input ref="gzdw" v-model="editData.gzdw" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人通信地址或经邮政部门批准使用的邮政信箱号
                                            </template>
                                            <a-form-item label="通信地址" :wrapper-col="{ span: 12 }">
                                                <a-input ref="txdz" v-model="editData.txdz" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得的专业技术职称名称。
                                            </template>
                                            <a-form-item label="专业技术职称" :wrapper-col="{ span: 12 }">
                                                <FGDictSelectCN ref="zyjszc" dictNo="XZJ200102" v-model="editData.zyjszc" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得专业技术职称的时间。按照年月填写。
                                            </template>
                                            <a-form-item label="职称获得时间" :wrapper-col="{ span: 12 }">
                                                <a-month-picker ref="zchdsj" v-model="editData.zchdsj" valueFormat="YYYY-MM-01" style="width:100%" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人从事工程咨询工作的年限。
                                            </template>
                                            <a-form-item label="从事工程咨询工作的年限">
                                                <a-input ref="csnx" v-model="editData.csnx" type="number" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人初次获得咨询工程师(投资)职业资格的时间。按照年月填写。
                                            </template>
                                            <a-form-item label="首次获得咨询工程师（投资）时间" :wrapper-col="{ span: 12 }">
                                                <a-month-picker
                                                    ref="schdzxgcssj"
                                                    v-model="editData.schdzxgcssj"
                                                    valueFormat="YYYY-MM-01"
                                                    style="width:100%"
                                                    disabled
                                                />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人咨询工程师(投资)证书登记的专业。
                                            </template>
                                            <a-form-item label="登记专业" :wrapper-col="{ span: 12 }">
                                                <a-input ref="djzy" v-model="editData.djzy" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得的其他职业或执业资格(资质)。
                                            </template>
                                            <a-form-item label="获得其他资格（资质）名称1" :wrapper-col="{ span: 12 }">
                                                <a-input ref="hdqtzgmc1" v-model="editData.hdqtzgmc1" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得的其他职业或执业资格(资质)的时间。按照年月填写。
                                            </template>
                                            <a-form-item label="获得时间1" :wrapper-col="{ span: 12 }">
                                                <a-month-picker ref="hdsj1" v-model="editData.hdsj1" valueFormat="YYYY-MM-01" style="width:100%" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得其他资格（资质）名称2" :wrapper-col="{ span: 12 }">
                                            <a-input ref="hdqtzgmc2" v-model="editData.hdqtzgmc2" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得时间2" :wrapper-col="{ span: 12 }">
                                            <a-month-picker ref="hdsj2" v-model="editData.hdsj2" valueFormat="YYYY-MM-01" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得其他资格（资质）名称3" :wrapper-col="{ span: 12 }">
                                            <a-input ref="hdqtzgmc3" v-model="editData.hdqtzgmc3" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得时间3" :wrapper-col="{ span: 12 }">
                                            <a-month-picker ref="hdsj3" v-model="editData.hdsj3" valueFormat="YYYY-MM-01" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="18">
                                        <a-tooltip>
                                            <template slot="title">
                                                按照申报专家类型和行业要求,重点填写申请人工作经历、主要工作领域、业务范畴、专业特长、参加过的重要工作和在工作中的职责、取得的主要成绩等。
                                            </template>
                                            <a-form-item label="工作简述" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                                <a-textarea v-model="editData.gzjs" :rows="3" placeholder="" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="用户名" :wrapper-col="{ span: 12 }">
                                            <a-input ref="yhm" v-model="editData.yhm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="密码" :wrapper-col="{ span: 12 }">
                                            <a-input ref="mm" v-model="editData.mm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="申报单位" :wrapper-col="{ span: 12 }">
                                            <a-input ref="sbdw" v-model="editData.sbdw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入部门" :wrapper-col="{ span: 12 }">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入人" :wrapper-col="{ span: 12 }">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入时间" :wrapper-col="{ span: 12 }">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel
                                title="本人主持或主导过主要业绩（包括编制行业标准）"
                                tooltip="指根据申请的专家类型,按照中国工程咨询协会专家所列标准填写相关业绩,可以增加业绩行数。"
                            >
                                <vxe-table
                                    ref="itemZYYJTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemZYYJData"
                                >
                                    <vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
                                    <vxe-table-column field="yjmc" title="业绩名称" align="center"> </vxe-table-column>
                                    <vxe-table-column field="wcsj" title="完成时间" align="center" width="180px"></vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel
                                title="近五年来获得的主要奖励"
                                tooltip="指申请人获得过的省协会优秀工程咨询成果（水平）二等奖以上及中国工程咨询协会优秀工程咨询成果奖三等及工程咨询类奖项或市级以上政府部分颁发的奖励等。"
                            >
                                <vxe-table
                                    ref="itemZYJLTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemZYJLData"
                                >
                                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                    <vxe-table-column field="hjxmmc" title="获奖项目名称" align="center"> </vxe-table-column>
                                    <vxe-table-column field="jxmcjdj" title="奖项名称及等级" align="center"> </vxe-table-column>
                                    <vxe-table-column field="pjdw" title="评奖单位" align="center"> </vxe-table-column>
                                    <vxe-table-column field="cyjs" title="A：负责人 B：参加者" align="center" width="180px"> </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel
                                title="参加意愿"
                                tooltip="愿意参与的工作选项(可多选):指申请人愿意参与的工作类型(填编号),可多选。例如:申报参与行业智库建设专家,在相应选项中填入Z ,同时参与学术类智库建设的,在相应选项中填入X1"
                            >
                                <vxe-table
                                    ref="itemCJYYTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemCJYYData"
                                    :span-method="rowspanMethod"
                                    :checkbox-config="{ trigger: 'row', highlight: false, range: true, showHeader: false }"
                                >
                                    <vxe-table-column field="zjlx" title="专家类型" width="180px" align="center"> </vxe-table-column>
                                    <vxe-table-column field="gzxx" title="工作选项（可多选）" align="left"> </vxe-table-column>
                                    <vxe-table-column
                                        field="gxbj"
                                        title="勾选自愿参加的选项"
                                        align="center"
                                        width="200px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot="scope">
                                            <a-checkbox :checked="scope.row.gxbj === 1" />
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload ref="attachdown" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "ZjxxrkForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isShow: false,
            // 主要业绩明细数据
            editItemZYYJData: [],
            editItemZYYJDataLoading: false,
            // 主要奖励明细数据
            editItemZYJLData: [],
            editItemZYJLDataLoading: false,
            // 参加意愿明细数据
            editItemCJYYData: [],
            editItemCJYYDataLoading: false
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg() {
            return {
                fktable: "XZJ_ZJRKB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "XZJ200102"
            };
        },
        attachImageCfg() {
            return {
                fktable: "XZJ_ZJRKB",
                fkvalue: this.editData.id
            };
        }
    },
    activated() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            if (data.data.zjlx && data.data.zjlx.length !== 0) {
                                this.editData.zjlx = data.data.zjlx.split(",");
                            }
                            this.loadItemZYYJData();
                            this.loadItemZYJLData();
                            this.loadItemCJYYData();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        // 加载主要业绩明细表数据
        loadItemZYYJData() {
            this.editItemZYYJData = [];
            this.editItemZYYJDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/listZYYJ",
                    {
                        zjrkbid: this.editDataId,
                        sort: {
                            field: "id",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemZYYJDataLoading = false;
                    if (success) {
                        this.editItemZYYJData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载主要奖励明细表数据
        loadItemZYJLData() {
            this.editItemZYJLData = [];
            this.editItemZYJLDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/listZYJL",
                    {
                        zjrkbid: this.editDataId,
                        sort: {
                            field: "id",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemZYJLDataLoading = false;
                    if (success) {
                        this.editItemZYJLData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载参加意愿明细表数据
        loadItemCJYYData() {
            this.editItemCJYYData = [];
            this.editItemCJYYDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/listCJYY",
                    {
                        zjrkbid: this.editDataId,
                        sort: {
                            field: "id",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemCJYYDataLoading = false;
                    if (success) {
                        this.editItemCJYYData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        //撤销操作
        onCancel(type) {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.loading = true;
                    this.$FG_http
                        .post("./api/main/zjxx/xzjrkgl/unSubmit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 设置当前行
                                this.lookDataId = this.editData.id;
                                // 返回列表
                                this.formIsVisible = false;
                            }
                        });
                }
            });
        },
        rowspanMethod({ row, _rowIndex, column, visibleData }) {
            const fields = ["zjlx"];
            const cellValue = row[column.property];
            if (cellValue && fields.includes(column.property)) {
                const prevRow = visibleData[_rowIndex - 1];
                let nextRow = visibleData[_rowIndex + 1];
                if (prevRow && prevRow[column.property] === cellValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[column.property] === cellValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}
</style>
